<template>
    <div class="card">
        <div class="card-header">
          <i class="fa fa-hospital-o"></i> {{$t('user.position.list')}}
          <create></create>
        </div>
        <div class="card-body p-1">
          <b-table striped hover responsive :items="items" :fields="field" :outlined="true" :fixed="true" head-variant="light">
            <template slot="status" slot-scope="position">
              <status :status="position.value" :options="options" @approval="approval(position.item)" @rejection="rejection(position.item)" />
            </template>
            <template slot="action" slot-scope="position">
              <b-dropdown variant="link" size="md" no-caret>
                <template slot="button-content">
                  <i class="fa fa-bars"></i>
                </template>
                <b-dropdown-item @click="edit(position.item)"><i class="fa fa-edit"></i>{{$t('user.position.button.edit')}}</b-dropdown-item>
                <b-dropdown-item @click="destroy(position.item)"><i class="fa fa-remove"></i>{{$t('user.position.button.delete')}}</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <div class="pt-3">
            <select name="total_user" v-model='per_page' required="required" @change="changePerPage">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
            {{$t('paginate.count')}} {{total}} {{$t('paginate.row')}}
            <paginate :page-count="last_page" :click-handler="changePage" :prev-text="$t('paginate.prev')" :next-text="$t('paginate.next')"
              :container-class="'pagination'" class="pull-right">
            </paginate>
          </div>
        </div>
        <b-modal ref="edit" size="lg" hide-footer :title="$t('user.position.message.edit')">
          <div class="d-block">
            <form action="" v-on:submit.prevent="update()">
              <fieldset role="group" class="b-form-group form-group">
                <div role="group" class="">
                  <label for="">{{$t('user.position.attribute.name')}} :</label>
                  <div role="group" class="input-group">
                    <input type="text" :placeholder="$t('user.position.attribute.name')" class="form-control" v-model="position.name">
                  </div>
                  <label for="name" style="color: red" v-if="errors.name">{{errors.name?errors.name[0]:''}}</label>
                </div>
              </fieldset>
              <fieldset role="group" class="b-form-group form-group">
                <div role="group" class="">
                  <label for="">{{$t('user.position.attribute.order')}} :</label>
                  <div role="group" class="input-group">
                    <input type="text" :placeholder="$t('user.position.attribute.order')" class="form-control" v-model="position.order">
                  </div>
                  <label for="name" style="color: red" v-if="errors.order">{{errors.order?errors.order[0]:''}}</label>
                </div>
              </fieldset>
              <button type="submit" class="btn btn-primary pull-right btn-sm" :disabled="btn_submit">
                <i class="fa fa-pencil"></i> {{$t('user.button.edit')}}</button>
            </form>
          </div>
        </b-modal>
      </div>
</template>
<script>
import Create from './create'
import Paginate from 'vuejs-paginate'
import swal from 'sweetalert'
import Status from '@/components/status'

export default {
  name: 'position',
  components: {Create, Paginate, Status},
  props: [],
  data () {
    return {
      per_page: 20,
      position: {},
      errors: {},
      btn_submit: false,
      field: [
        {
          key: 'name',
          sortable: true,
          label: this.$t('common.name')
        },
        {
          key: 'order',
          sortable: true,
          label: this.$t('common.order')
        },
        {
          key: 'status',
          label: this.$t('common.status')
        },
        {
          key: 'action',
          label: this.$t('common.action')
        }
      ]
    }
  },
  computed: {
    items () {
      return this.$store.getters['Position/getListPosition']
    },
    total () {
      return this.$store.getters['Position/getTotal']
    },
    last_page () {
      return this.$store.getters['Position/getLastpage']
    },
    options () {
      return this.$store.getters['Status/getStatusCheckerMaker']
    },
    fields () {
      return this.$store.getters['Position/getField']
    }
  },
  mounted () {
    Promise.all([
      this.$store.dispatch('Position/getListPosition', {page: 1, per_page: this.per_page}),
      this.$store.dispatch('Status/getListStatus')
    ]).then(res => {

    }).catch(errors => {

    })
  },
  methods: {
    clickCallback (page) {
      this.$store.dispatch('Position/getListPosition', {page: page, per_page: this.per_page}).then(res => {
      }).catch(errors => {
      })
    },
    changePerPage () {
      this.$store.dispatch('Position/getListPosition', {page: 1, per_page: this.per_page}).then(res => {
      }).catch(errors => {
      })
    },
    edit (position) {
      this.$store.dispatch('Position/showPosition', {position: position}).then(res => {
        this.position = res

        this.$refs.edit.show()
      }).catch(errors => {

      })
    },
    update () {
      this.btn_submit = true
      this.$store.dispatch('Position/updatePosition', {position: this.position}).then(res => {
        this.btn_submit = false
        this.$refs.edit.hide()
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {
        this.btn_submit = false
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
      })
    },
    destroy (position) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$store.dispatch('Position/destroyPosition', {
              position: position
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
            }).catch(errors => {

            })
          }
        })
    },
    approval (position) {
      this.$store.dispatch('Position/approvalPosition', {
        position
      }).then(res => {

      }).catch(errors => {

      })
    },
    rejection (position) {
      this.$store.dispatch('Position/rejectPosition', {
        position
      }).then(res => {

      }).catch(errors => {

      })
    }
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/position/index.vue